import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {Link, withRouter} from 'react-router-dom';
import {FairList} from 'components/fair';

export default class Fair extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <MainLayout>
        <div>
          <div className='wrap-heading'>
            <h1>Quản lý Hội chợ</h1>
            <div className='list-actions'>
              <Link to="fair/add">Thêm Hội chợ mới</Link>
            </div>
          </div>
          <FairList />
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/Fair.jsx